module.exports = __webpack_public_path__ + "assets/img/num-03-a43a4f01.png";